// extracted by mini-css-extract-plugin
export default {"card":"Fu5MtW","flex-content":"GgAkCu","eyebrow":"ZUw0Ju","title":"TpvUBk","featured":"S3OSt8","icon":"Gd9W3K","spacer":"vE6Kq9"};